'use strict';

const Reflux = require('@muzzylane/reflux');
const uuid = require('uuid')
const filter = require('lodash/filter');
const find = require('lodash/find');
const findIndex = require('lodash/findIndex');
const assign = require('lodash/assign');
const reject = require('lodash/reject');

const Globals = require('../../../app/globals');
const ProjectActions = require('../actions/ProjectActions');
const ChannelActions = require('../actions/ChannelActions');
const ActivityActions = require('../actions/ActivityActions');
const OrganizationActions = require('../actions/OrganizationActions');
const SignInStore = require('./SignInStore');
const ForgeError = require('../util/error');
const ErrorConsts = require('../constants/error');
const SignInActions = require('../actions/sign_in_actions');

let projects = [];
let projectTags = {};
let shortCourseProjects = [];
let initialized = false;
let action = {};

var ProjectStore = Reflux.createStore({
    listenables: [ProjectActions, SignInActions, OrganizationActions, ActivityActions],
    init: function() {
        if (SignInStore.getState().initializedLocal) {
            ProjectActions.getAllProjects(uuid.v4());
        }

        this.listenTo(SignInStore, this.onSignInChange);
    },

    resetState: function() {
        projects = [];
        shortCourseProjects = [];
        projectTags = {};
        // initialized = false;
        // action = {};
    },

    onSignOutCompleted: function(res) {
        this.resetState();
        this.emitStatus();
    },

    onSignOutFailed: function(err) {
        console.warn(err);
        this.resetState();
        this.emitStatus();
    },

    onSignInChange: function(signInStoreState){
        if(signInStoreState.initializedLocal){
            ProjectActions.getAllProjects(uuid.v4());
        }
    },

    getState: function() {
        return {
            initialized: initialized,
            projects: projects,
            shortCourseProjects: shortCourseProjects,
            projectTags: projectTags,
            action: action,
        }
    },

    getStateChannel: function(channelId) {
        return {
            initialized: initialized,
            projects: filter(projects, { channelId: parseInt(channelId, 10) }),
            shortCourseProjects: filter(shortCourseProjects, { channelId: parseInt(channelId, 10) }),
            action: action,
        }
    },

    getStateProject: function(id) {
        const parsedId = parseInt(id, 10);
        return {
            initialized: initialized,
            project: find(projects, { id: parsedId }),
            shortCourseProject: find(shortCourseProjects, { id: parsedId }),
            action: action,
        }
    },

    emitStatus: function() {
        this.trigger(this.getState());
        action = {};
    },

    onError: function(actionId, err) {
        action = { id: actionId };

        if (err.status) {
            switch (err.status) {
                case 403:
                    action.error = new ForgeError({ message: err.responseText });
                    break;
                default:
                    action.error = new ForgeError({message: ErrorConsts.INTERNAL_GENERAL, stack: err.responseText || null});
                    break;
            }
        }
        else {
            action.error = err;
        }

        this.emitStatus();
    },

    _upsertProject(newProj) {
        let replaced;
        if (newProj.content_type === Globals.content_type.ACTIVITY) {
            projects = projects.map((p) => {
                if (p.id === newProj.id) {
                    replaced = true;
                    return newProj;
                }

                return p;
            });

            if (!replaced) {
                projects.push(newProj);
            }
        }
        else if (newProj.content_type === Globals.content_type.COURSE) {
            shortCourseProjects = shortCourseProjects.map((p) => {
                if (p.id === newProj.id) {
                    replaced = true;
                    return newProj;
                }

                return p;
            });

            if (!replaced) {
                shortCourseProjects.push(newProj);
            }
        }
    },

    _updateProjectData: function(projectId, changes) {
        const parsedId = parseInt(projectId, 10);
        const indexProjects = findIndex(projects, { id: parsedId });
        if (indexProjects >= 0) {
            projects[indexProjects] = assign({}, projects[indexProjects], changes);
        }
        else {
            const indexScProjects = findIndex(shortCourseProjects, { id: parsedId });
            if (indexScProjects >= 0) {
                shortCourseProjects[indexScProjects] = assign({}, shortCourseProjects[indexScProjects], changes);
            }
        }
    },

    _addProjectIntegrationTag: function(projectId, tagInfo) {
        if (!projectTags[projectId]) projectTags[projectId] = [];

        if (projectTags[projectId].indexOf(t => t.tag === tagInfo.tag) < 0) {
            projectTags[projectId].push(tagInfo);
        }

        const parsedId = parseInt(projectId, 10);
        const projectIndex = findIndex(projects, { id: parsedId });
        if (projectIndex >= 0) {
            const tagIndex = findIndex(projects[projectIndex].integration_tags, t => t.id === tagInfo.id);
            if (tagIndex >= 0) { // replace (update)
                projects[projectIndex].integration_tags.splice(tagIndex, 1, tagInfo);
            }
            else { // add
                projects[projectIndex].integration_tags.push(tagInfo);
            }
        }
        else {
            const indexScProjects = findIndex(shortCourseProjects, { id: parsedId });
            if (indexScProjects >= 0) {
                const tagIndex = findIndex(shortCourseProjects[indexScProjects].integration_tags, t => t.id === tagInfo.id);
                if (tagIndex >= 0) { // replace (update)
                    shortCourseProjects[indexScProjects].integration_tags.splice(tagIndex, 1, tagInfo);
                }
                else { // add
                    shortCourseProjects[indexScProjects].integration_tags.push(tagInfo);
                }
            }
        }
    },

    _removeProjectIntegrationTag: function(projectId, tagInfo) {
        const pTagsTagIndex = !!projectTags[projectId] ? projectTags[projectId].indexOf(t => t.tag === tagInfo.tag) : -1;
        if (pTagsTagIndex >= 0) {
            projectTags[projectId].splice(pTagsTagIndex, 1);
        }

        const parsedId = parseInt(projectId, 10);
        const projectIndex = findIndex(projects, { id: parsedId });
        if (projectIndex >= 0) {
            const tagIndex = findIndex(projects[projectIndex].integration_tags, t => t.id === tagInfo.id);
            if (tagIndex >= 0) { // remove
                projects[projectIndex].integration_tags.splice(tagIndex, 1);
            }
        }
        else {
            const indexScProjects = findIndex(shortCourseProjects, { id: parsedId });
            if (indexScProjects >= 0) {
                const tagIndex = findIndex(shortCourseProjects[indexScProjects].integration_tags, t => t.id === tagInfo.id);
                if (tagIndex >= 0) { // remove
                    shortCourseProjects[indexScProjects].integration_tags.splice(tagIndex, 1);
                }
            }
        }
    },

    onGetAllProjectsCompleted: function(actionId, res) {
        action = { id: actionId };
        initialized = true;
        projects = [];
        shortCourseProjects = [];
        res.projects.forEach((project) => {
            if (project.content_type === Globals.content_type.ACTIVITY) {
                projects.push(project);
            }
            else if (project.content_type === Globals.content_type.COURSE) {
                shortCourseProjects.push(project);
            }
        });

        this.emitStatus();
    },

    onGetAllProjectsFailed: function(actionId, err) {
        let error;
        switch (err.status) {
            case 403:
                error = new ForgeError({message: ErrorConsts.FETCH_FAILED_PROJECTS + ": " + ErrorConsts.FORBIDDEN});
                break;
            default:
                error = new ForgeError({message: ErrorConsts.FETCH_FAILED_PROJECTS + ": " + ErrorConsts.INTERNAL_GENERAL});
        }

        action = { id: actionId, error: error };
        initialized = true;
        this.emitStatus();
    },

    onCreateProjectCompleted: function(actionId, newProj) {
        // console.log("onCreateProjectCompleted: ", actionId, newProj);
        action = { id: actionId };
        // replace project if exists in store (likely unnecessary)
        this._upsertProject(newProj);
        this.emitStatus();
    },

    onCreateProjectFailed: function(actionId, err) {
        console.warn("onCreateProjectFailed: ", actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onArchiveProjectCompleted: function(actionId, projectId, res) {
        action = { id: actionId };
        const parsedId = parseInt(projectId, 10);
        projects = projects.filter(p => p.id !== parsedId);
        shortCourseProjects = shortCourseProjects.filter(p => p.id !== parsedId);
        this.emitStatus();
    },

    onArchiveProjectFailed: function(actionId, projectId, err) {
        console.warn("onArchiveProjectFailed: ", actionId, projectId, err);
        this.onError(actionId, err);
    },

    onRenameProjectCompleted: function(actionId, projectId, name, res) {
        //console.log("onRenameProjectCompleted: ", res);
        action = { id: actionId };

        let found = false;
        const parsedId = parseInt(projectId, 10);
        projects = projects.map((p) => {
            if (p.id === parsedId) {
                found = true;
                return { ...p, name: name };
            }

            return p;
        });

        if (!found) {
            shortCourseProjects = shortCourseProjects.map((p) => {
                if (p.id === parsedId) {
                    found = true;
                    return { ...p, name: name };
                }

                return p;
            });
        }

        if (!found) {
            console.warn(`onRenameProjectCompleted: Unable to find project ${projectId} in store. Refreshing projects`);
            ProjectActions.getAllProjects(uuid.v4());
        }

        this.emitStatus();
    },

    onRenameProjectFailed: function(actionId, err) {
        console.warn("onRenameProjectFailed: ", actionId, err);
        action = { id: actionId, error: err };
        //todo: parse err.status if required
        this.emitStatus();
    },

    onUpdateProjectDescriptionCompleted: function(actionId, projectId, description, res) {
        //console.log("onUpdateProjectDescriptionCompleted: ", res);
        action = { id: actionId };
        this._updateProjectData(projectId, { description: description });
        this.emitStatus();
    },

    onUpdateProjectDescriptionFailed: function(actionId, err) {
        console.warn("onUpdateProjectDescriptionFailed: ", actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onCopyProjectCompleted: function(actionId, newProj) {
        //console.log("onCopyProjectCompleted: ", res);
        action = { id: actionId };
        // replace project if exists in store (likely unnecessary)
        this._upsertProject(newProj);
        this.emitStatus();
    },

    onCopyProjectFailed: function(actionId, err) {
        console.warn("onCopyProjectFailed: ", actionId, err);
        action = { id: actionId, error: err };
        //todo: parse err.status if required
        this.emitStatus();
    },

    onTransferProjectCompleted: function(actionId, newProj) {
        //console.log("onTransferProjectCompleted: ", res);
        action = { id: actionId };
        this._upsertProject(newProj);
        this.emitStatus();
    },

    onTransferProjectFailed: function(actionId, err) {
        console.warn("onTransferProjectFailed: ", actionId, err);
        action = { id: actionId, error: err };
        //todo: parse err.status if required
        this.emitStatus();
    },

    onGetProjectTagsCompleted: function(actionId, projectId, tagRecords) {
        action = { id: actionId };
        projectTags[projectId] = tagRecords;
        this._updateProjectData(projectId, {
            tags: tagRecords.map(t => t.tag), // DEPRECATED
            integration_tags: tagRecords,
        });
        this.emitStatus();
    },

    onGetProjectTagsFailed: function(actionId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onAddProjectTagCompleted: function(actionId, projectId, tagRecord, res) {
        action = { id: actionId };
        if (projectTags[projectId].indexOf(t => t.id === tagRecord.id) < 0) {
            projectTags[projectId].push(tagRecord);
            this._updateProjectData(projectId, {
                tags: projectTags[projectId].map(t => t.tag), // DEPRECATED
                integration_tags: projectTags[projectId],
            });
        }

        this.emitStatus();
    },

    onAddProjectTagFailed: function(actionId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onAddProjectTagsCompleted: function(actionId, projectId, tagRecords, res) {
        action = { id: actionId };

        tagRecords.forEach((tagRecord) => {
            if (projectTags[projectId].indexOf(t => t.id === tagRecord.id) < 0) {
                projectTags[projectId].push(tagRecord);
                this._updateProjectData(projectId, {
                    // tags: projectTags[projectId].map(t => t.tag), // DEPRECATED
                    integration_tags: projectTags[projectId],
                });
            }
        });


        this.emitStatus();
    },

    onAddProjectTagsFailed: function(actionId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onDeleteProjectTagCompleted: function(actionId, projectId, tagRecord, res) {
        // console.log('onDeleteProjectTagCompleted', actionId, projectId, tagRecord, res);
        action = { id: actionId };
        projectTags[projectId] = reject(projectTags[projectId], pTag => pTag.id === tagRecord.id);
        this._updateProjectData(projectId, {
            tags: projectTags[projectId].map(t => t.tag), // DEPRECATED
            integration_tags: projectTags[projectId],
        });
        this.emitStatus();
    },

    onDeleteProjectTagFailed: function(actionId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onManageOrgIntegrationTagCompleted: function(actionId, orgId, managementTasks, tagInfo) {
        const self = this;
        action = { id: actionId };

        if (managementTasks.add.projects) {
            Object.keys(managementTasks.add.projects).forEach((projectId) => {
                self._addProjectIntegrationTag(projectId, tagInfo);
            });
        }

        if (managementTasks.remove.projects) {
            Object.keys(managementTasks.remove.projects).forEach((projectId) => {
                self._removeProjectIntegrationTag(projectId, tagInfo);
            });
        }

        this.emitStatus();
    },

    onManageOrgIntegrationTagFailed: function(actionId, orgId, managementTasks, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onDeleteFolderCompleted: function(actionId, folderId, channelId, res) {
        projects = projects.filter(p => res.deletedProjectIds.indexOf(p.id) < 0);
        this.emitStatus();
    },

    onTransferActivityCompleted: function(actionId, activityId, toProjectId, fromProjectId, res) {
        projects = projects.map((project) => {
            if (project.id === fromProjectId) {
                project.activity_count -= 1;
            }
            else if (project.id === toProjectId) {
                project.activity_count += 1;
            }

            return project;
        });

        this.emitStatus();
    },

});

module.exports = ProjectStore;
